import { createSlice } from '@reduxjs/toolkit';
import { CATEGORIES_DISPLAY_LIMIT } from 'pages/Category/CategoryConstants';
import { CategorySearchFilters } from 'types/category/categoryTypes';
import { PageDetails } from 'types/common/Table';

interface CategoryState {
  PageFilters: CategorySearchFilters;
  PageDetails: PageDetails;
}

export const initialState: CategoryState = {
  PageFilters: {
    categoryName: '',
  },
  PageDetails: {
    entriesPerPage: CATEGORIES_DISPLAY_LIMIT,
    currentPage: 0,
    inputPageValue: 1,
  },
};

const CategorySlice = createSlice({
  name: 'Category',
  initialState,
  reducers: {
    setPageFilters: (state, action) => {
      state.PageFilters = action.payload;
    },
    clearPageFilters: (state) => {
      state.PageFilters = {
        categoryName: '',
      };
    },
    setEntriesPerPage: (state, action) => {
      state.PageDetails.entriesPerPage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.PageDetails.currentPage = action.payload;
      state.PageDetails.inputPageValue = action.payload + 1;
    },
    setInputPageValue: (state, action) => {
      state.PageDetails.inputPageValue = action.payload;
    },
  },
});

export const {
  setPageFilters,
  clearPageFilters,
  setEntriesPerPage,
  setCurrentPage,
  setInputPageValue,
} = CategorySlice.actions;

export default CategorySlice.reducer;
